import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OfflineSharedService {
  private fireShowAccionesLocales: BehaviorSubject<boolean>;

  constructor() {
    this.fireShowAccionesLocales = new BehaviorSubject<boolean>(false);
  }

  getActualizarPanelAccionesLocales(): Observable<boolean> {
    return this.fireShowAccionesLocales.asObservable();
  }

  setActualizarPanelAccionesLocales(status): void {
    this.fireShowAccionesLocales.next(status);
  }
}
